// @ts-nocheck
import common from "@store/Themes/common";
import * as styleguide from "@store/Themes/csds/styleguide";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(common, styleguide);
